"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { Database, Map, ArrowRight } from "lucide-react";
export default function BoilerInstallationDublin() {
  return <section data-section-id="243045" id="boiler-installation-dublin" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32 min-h-[80vh] flex items-center">
      {}
      <style>{`
        @keyframes tectonic-shift-1 {
          0% { transform: translate(0, 0) rotate(-4deg) scale(1); }
          50% { transform: translate(2%, 1%) rotate(-4deg) scale(1.02); }
          100% { transform: translate(0, 0) rotate(-4deg) scale(1); }
        }
        @keyframes tectonic-shift-2 {
          0% { transform: translate(0, 0) rotate(3deg) scale(1); }
          50% { transform: translate(-1.5%, -1%) rotate(3deg) scale(1.01); }
          100% { transform: translate(0, 0) rotate(3deg) scale(1); }
        }
        @keyframes tectonic-shift-3 {
          0% { transform: translate(0, 0) rotate(12deg); }
          50% { transform: translate(1%, -2%) rotate(12deg); }
          100% { transform: translate(0, 0) rotate(12deg); }
        }
        .animate-tectonic-1 { animation: tectonic-shift-1 30s ease-in-out infinite; }
        .animate-tectonic-2 { animation: tectonic-shift-2 40s ease-in-out infinite; }
        .animate-tectonic-3 { animation: tectonic-shift-3 35s ease-in-out infinite; }
      `}</style>

      {}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden opacity-40">
        {}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-background)_0%,transparent_100%)] z-10" />
        
        {}
        <div className="absolute top-[20%] left-[-10%] w-[120%] h-[2px] bg-gradient-to-r from-transparent via-primary/30 to-transparent animate-tectonic-1 origin-left" />
        <div className="absolute top-[60%] left-[-10%] w-[120%] h-[1px] bg-gradient-to-r from-transparent via-muted-foreground/20 to-transparent animate-tectonic-2 origin-right" />
        <div className="absolute top-[-10%] left-[30%] w-[1px] h-[120%] bg-gradient-to-b from-transparent via-primary/20 to-transparent animate-tectonic-3 origin-top" />
        <div className="absolute top-[-10%] left-[70%] w-[2px] h-[120%] bg-gradient-to-b from-transparent via-secondary/40 to-transparent animate-tectonic-1 origin-bottom" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {}
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary/10 border border-primary/20 mb-8 backdrop-blur-sm">
            <Database className="w-4 h-4 text-primary" />
            <span className="text-xs font-mono tracking-widest uppercase text-primary">
              RGI Registered & Fully Insured
            </span>
          </div>

          {}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-default font-bold mb-8 tracking-tighter leading-[1.1] text-foreground">
            Premium Boiler <br className="hidden md:block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-chart-2">
              Installation Dublin
            </span>
          </h1>

          {}
          <p className="text-lg md:text-xl text-muted-foreground mb-12 font-default leading-relaxed max-w-3xl mx-auto">
            Upgrade to a high-efficiency heating system with D4 Plumbing & Heating. We provide expert gas boiler replacements, ensuring your home stays warm and energy-efficient all year round.
          </p>

          {}
          <div className="max-w-md mx-auto bg-card/60 backdrop-blur-md border border-border/50 p-6 rounded-lg shadow-2xl mb-12 text-left">
            <div className="flex justify-between items-end mb-3">
              <div>
                <h3 className="text-sm font-default font-bold text-foreground mb-1">
                  Installation Package Includes
                </h3>
                <p className="text-xs font-mono text-muted-foreground">
                  Gas Safety Cert & Powerflush
                </p>
              </div>
              <span className="text-lg font-mono font-bold text-primary">
                100%
              </span>
            </div>
            <Progress value={100} className="h-2 bg-background/50" />
            <div className="mt-4 flex items-center gap-2 text-xs text-muted-foreground">
              <Map className="w-3.5 h-3.5" />
              <span>Smart Controls & Professional Commissioning Included</span>
            </div>
          </div>

          {}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button asChild size="lg" className="w-full sm:w-auto group bg-primary hover:bg-primary/90 text-primary-foreground rounded-md shadow-lg">
              <Link to="tel:+35319081819">
                Call 01 908 1819
                <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto bg-background/50 backdrop-blur-sm border-primary/30 hover:bg-primary/10 rounded-md">
              <Link to="/BoilerInstallationPage">
                View Installation Options
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}